import { render, staticRenderFns } from "./PageGoals.vue?vue&type=template&id=6439e555"
import script from "./PageGoals.vue?vue&type=script&lang=js"
export * from "./PageGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports